import { render, staticRenderFns } from "./inquiry-report-maintenance.vue?vue&type=template&id=47a7ae2f&"
import script from "./inquiry-report-maintenance.vue?vue&type=script&lang=js&"
export * from "./inquiry-report-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports